module.exports = __webpack_public_path__ + "img/8-2.13ac4f49.png";